import { useParams, useSearchParams } from "react-router-dom";
import api from "../../services/api";
import { useState, useEffect } from "react";
import { confirmAlert } from "react-confirm-alert";
import 'react-confirm-alert/src/react-confirm-alert.css';
import "./receber.css";
import api_cnpj from "../../services/api_cnpj";
import { formatar, mask } from "../../services/react-format";

function Receber(props){
   //console.log('Receber:  carregando variáveis');
  const [searchParams    , setSearchParams]    = useSearchParams();
  const [usuario         , setUsuario        ]= useState("ADM");
  const [cod_transacao   , setCodTransacao   ]= useState(-1);
  const [cont_id         , setContID         ]= useState(-1);
  const [trans_descr     , setTransDescr     ]= useState("");
  const [trans_dt_vencto , setTransDtVencto  ]= useState("");
  const [trans_valor     , setTransValor     ]= useState(0);
  const [trans_status    , setTransStatus    ]= useState("");
  const [alterado        , setAlterado       ]= useState(false);
  const [cont_cgc_cpf    , setContCgc_cpf    ]= useState("");
  const [cont_nome       , setContNome       ]= useState("");
  const [cont_endereco   , setContEndereco   ]= useState("");
  const [cont_numero     , setContNumero     ]= useState("");
  const [cont_complemento, setContComplemento]= useState("");
  const [cont_bairro     , setContBairro     ]= useState("");
  const [cont_cep        , setContCep        ]= useState("");
  const [cont_cidade     , setContCidade     ]= useState("");
  const [cont_uf         , setContUf         ]= useState("");
  const [cont_residencial, setContResidencial]= useState("");
  const [cont_email      , setContEmail      ]= useState("");
  //console.log('Receber: carregamento finalizado');

  var CNPJCliente    = searchParams.get("cnpj");
  var UsuarioSpartan = searchParams.get("usuario");  

  useEffect(() => {
    setUsuario(props.usuario);
    setCodTransacao(props.cod_transacao);
    setContID(props.cont_id);
    setTransDescr(props.trans_descr);
    setTransDtVencto(props.trans_dt_vencto);
    setTransStatus(props.trans_status);
    setTransValor(props.trans_valor);
    setContCgc_cpf(props.cont_cgc_cpf);
    setContNome(props.cont_nome);
    setContEndereco(props.cont_endereco);
    setContNumero(props.cont_numero);
    setContComplemento(props.cont_complemento);
    setContBairro(props.cont_bairro);
    setContCep(props.cont_cep);
    setContCidade(props.cont_cidade);
    setContUf(props.cont_uf);
    setContResidencial(props.cont_residencial);
    setContEmail(props.cont_email);
  },[props])


  // function handleValor(e){
  //   let obj = formatar(e.target,"money"); //target = objeto input que coloquei a funcao la em baixo
  //   //console.log('handleValor: ' + obj)
  //   setTransValor(obj.value);
  //   setAlterado(true);    
  // }
  function handleCnpj(e){
    let obj=formatar(e.target,"cnpjorcpf");
    //console.log('handleCnpj: ' + obj)
    setContCgc_cpf(obj.value);
    //  e.target.value.length>=13 ? PesquisaCNPJ(e.target.value):<></>
     setAlterado(true)    
  };

  function PesquisaCNPJ(cnpj, inputid){
    cnpj = cnpj.replaceAll("/","").replaceAll(".","").replaceAll("-","");
    //console.log('PesquisaCNPJ:' + encodeURI(cnpj));
    if (cnpj == "") {
      //console.log("CNPJ não informado"); 
      //console.log("ID campo:"+ inputid); 
      return;
    };

    if (cnpj !== undefined) {
      api.get("/erp/lead",{params: {cnpj}})
      .then((resp) => {  //aguarda a resposta do comando get anterior          
        ////console.log(JSON.stringify(resp.data));
        document.getElementById(inputid).value = resp.data.cont_nome;
        //console.log("Pesquisa Lead retornou: " + resp.data.cont_nome);
        //console.log("Campo alterado: " + inputid);
        setContCgc_cpf(resp.data.cont_cgc_cpf);
        setContNome(resp.data.cont_nome);
        setContEndereco(resp.data.cont_endereco);
        setContNumero(resp.data.cont_numero);
        setContComplemento(resp.data.cont_complemento);
        setContBairro(resp.data.cont_bairro);
        setContCep(resp.data.cont_cep);
        setContCidade(resp.data.cont_cidade);
        setContUf(resp.data.cont_uf);
        setContResidencial(resp.data.cont_residencial);
        setContEmail(resp.data.cont_email);      
      })
    .catch((err) => {     
                      //alert('Não foi possível encontrar os dados para este CNPJ') ;
                      //console.log("Erro na pesquisa CNPJ");
                      //console.log(err);
                      setContCgc_cpf("");
                      setContNome("Não encontrado");
                      setContEndereco("");
                      setContNumero("");
                      setContComplemento("");
                      setContBairro("");
                      setContCep("");
                      setContCidade("");
                      setContUf("");
                      setContResidencial("");
                      setContEmail("");
                    }
          );

    if ((cont_nome == "")||(cont_nome == "Não encontrado"))
    {
      api_cnpj.get("/"+encodeURI(cnpj))
      .then((resp) => {  //aguarda a resposta do comando get anterior          
          ////console.log(JSON.stringify(resp.data));
          //console.log("Dados do receitaws.com.br: " + resp.data.nome);
          document.getElementById(inputid).value =resp.data.nome;
          setContCgc_cpf(resp.data.cnpj);
          setContNome(resp.data.nome);
          setContEndereco(resp.data.logradouro);
          setContNumero(resp.data.numero);
          setContComplemento(resp.data.complemento);
          setContBairro(resp.data.bairro);
          setContCep(resp.data.cep);
          setContCidade(resp.data.municipio); 
          setContUf(resp.data.uf);
          setContResidencial(resp.data.telefone);
          setContEmail(resp.data.email);      
      })
      .catch((err) => {
          //alert('Não foi possível encontrar os dados para este CNPJ') ;
          setContCgc_cpf("");
          setContNome("Não encontrado");
          setContEndereco("");
          setContNumero("");
          setContComplemento("");
          setContBairro("");
          setContCep("");
          setContCidade("");
          setContUf("");
          setContResidencial("");
          setContEmail("");
      });
  
    } 
    else {
          setContCgc_cpf("");
          setContNome("");
          setContEndereco("");
          setContNumero("");
          setContComplemento("");
          setContBairro("");
          setContCep("");
          setContCidade("");
          setContUf("");
          setContResidencial("");
          setContEmail("");
        };
  
    };


  };

    
  function ExcluirReceber(props){
    confirmAlert({
        title: 'Exclusão',
        message: 'Confirma exclusão? Valor:'+[props.trans_valor],
        buttons: [
          {
            label: 'Sim',
            onClick: (codtrans=props.cod_transacao) => {              
              ////console.log(props);
              api.delete("/erp/receber?CNPJ="+CNPJCliente+"&usuario="+UsuarioSpartan+"&id="+props.id)
              .then((resp) => {  //aguarda a resposta do comando get anterior
                ////console.log(resp.data);
                if (resp.data.status == 'OK') {
                  props.onClose();
                }else{
                  alert(resp.data.mensagem);
                }
              })
              .catch((err) => {
                  alert('Falha ao excluir ID: '+props.cod_transacao + ' Mensagem: '+err) ;
              });
            }
            
          },
          {
            label: 'Não',
            onClick: () => {}
          }
        ]
      });
  };

  function SalvarReceber(props){   
    //console.log("Chammando função SalvarReceber...");
    const receber_params = {
      usuario,
      cod_transacao,
      cont_id,
      trans_descr,
      trans_dt_vencto,
      trans_status,
      trans_valor,
      cont_cgc_cpf,
      cont_nome,
      cont_endereco,
      cont_numero,
      cont_complemento,
      cont_bairro,
      cont_cep,
      cont_cidade,
      cont_uf,
      cont_residencial,
      cont_email
    };        
      if (cont_nome == "") {
        { 
          alert("Realize a pesquisa por CNPJ para preenchimento dos campos");
          return;
        }
      };
      //console.log("trans_dt_vencto: " +trans_dt_vencto);
      if ((trans_dt_vencto == undefined)||(trans_dt_vencto == "")) {
        { 
          alert("Verifique a data de vencimento "+trans_dt_vencto);
          return;
        }
      };
      if ((trans_valor == undefined) ||(trans_valor == 0)) {
        { 
          alert("Verifique o valor");
          return;
        }
      };

      //console.log("chamando rota /erp/receber"); 
      console.log("/erp/receber?CNPJ="+CNPJCliente+"&usuario="+UsuarioSpartan + ' receber_params: '+JSON.stringify(receber_params));
      api.post("/erp/receber?CNPJ="+CNPJCliente+"&usuario="+UsuarioSpartan,receber_params)
      .then((resp) => {  //aguarda a resposta do comando get anterior
        //console.log("Resp do post na rota /erp/receber: "+resp.data);
        if (resp.status ==201){
          //console.log("Resposta 201: " + resp.data);
          //alert('A Receber incluído. ID: '+resp.data.cod_transaacao);                      
          props.onClose();
          setAlterado(false);
          setCodTransacao(-1);
          setContID(-1);
          setTransDescr("");
          setTransDtVencto("");
          setTransStatus("");
          setTransValor("");
          setContCgc_cpf("");
          setContNome("");
          setContEndereco("");
          setContNumero("");
          setContComplemento("");
          setContBairro("");
          setContCep("");
          setContCidade("");
          setContUf("");
          setContResidencial("");
          setContEmail("");
    
        } else {
          //console.log("Resposta diferente de 201: " + resp.data.mensagem);
          alert("O seguinte erro foi retornado: "+resp.data.mensagem);
        }
        //console.log("fim do post");

      })
      .catch((err) => {
        //console.log("Erro Catch: " + err);
        alert('Falha ao gravar dados: '+err);
      });

    };

    function SalvarAlteracaoReceber(props){   
      //console.log("Chammando função SalvarAlteracaoReceber...");
      const receber_params = {
        usuario: UsuarioSpartan,
        cod_transacao,
        cont_id,
        trans_descr,
        trans_dt_vencto,
        trans_status,
        trans_valor,
        cont_cgc_cpf,
        cont_nome,
        cont_endereco,
        cont_numero,
        cont_complemento,
        cont_bairro,
        cont_cep,
        cont_cidade,
        cont_uf,
        cont_residencial,
        cont_email
      };        
        if (cont_nome == "") {
          { 
            alert("Realize a pesquisa por CNPJ para preenchimento dos campos");
            return;
          }
        };
        //console.log("trans_dt_vencto: " +trans_dt_vencto);
        if ((trans_dt_vencto == undefined)||(trans_dt_vencto == "")) {
          { 
            alert("Verifique a data de vencimento "+trans_dt_vencto);
            return;
          }
        };
        if ((trans_valor == undefined) ||(trans_valor == 0)) {
          { 
            alert("Verifique o valor");
            return;
          }
        };
  
        api.delete("/erp/receber?CNPJ="+CNPJCliente+"&usuario="+UsuarioSpartan+"&id="+props.cod_transacao)
        .then((resp) => {  //aguarda a resposta do comando get anterior
          ////console.log(resp.data);
          if (resp.data.status == 'OK') {
            props.onClose();
          }else{
            alert(resp.data.mensagem);
          }
        })
        .catch((err) => {
            alert('Falha ao excluir ID: '+props.cod_transacao + ' Mensagem: '+err) ;
        });        
        //console.log("chamando rota /erp/receber"); 
        //console.log("/erp/receber?CNPJ="+CNPJCliente+"&usuario="+UsuarioSpartan);
        api.post("/erp/receber?CNPJ="+CNPJCliente+"&usuario="+UsuarioSpartan,receber_params)
        .then((resp) => {  //aguarda a resposta do comando get anterior
          //console.log("Resp do post na rota /erp/receber: "+resp.data);
          if (resp.status ==201){
            //console.log("Resposta 201: " + resp.data);
            //alert('A Receber incluído. ID: '+resp.data.cod_transaacao);                      
            props.onClose();
            setAlterado(false);
            setCodTransacao(-1);
            setContID(-1);
            setTransDescr("");
            setTransDtVencto("");
            setTransStatus("");
            setTransValor("");
            setContCgc_cpf("");
            setContNome("");
            setContEndereco("");
            setContNumero("");
            setContComplemento("");
            setContBairro("");
            setContCep("");
            setContCidade("");
            setContUf("");
            setContResidencial("");
            setContEmail("");
      
          } else {
            //console.log("Resposta diferente de 201: " + resp.data.mensagem);
            alert("O seguinte erro foi retornado: "+resp.data.mensagem);
          }
          //console.log("fim do post");
  
        })
        .catch((err) => {
          //console.log("Erro Catch: " + err);
          alert('Falha ao gravar dados: '+err);
        });
  
      };    

  
    return <form className="row g-2 needs-validation mt-0 mb-0" noValidate id={"codtransid_"+cod_transacao}>  
    {/* <div className="input-group" id={props.id}> */}
      <div className="col-md-3">
        <div className="input-group mb-3">
          {/* <MaskedInput              
             mascara="99.999.999/9999-99"
             value={props.cnpj}
             onChange={(event)=>setContCgc_cpf(event.target.value)}
             meuid={"cont_cnpj"+props.id}/> */}
          {/* <label for="cnpj" className="form-label">CNPJ</label> */}
          <input type="text" 
                 id={"cont_cnpj"+cod_transacao} 
                 className="form-control"   
                 value ={cont_cgc_cpf}
                //  defaultValue ={(props.cnpj==11) ? mask("###.###.###-##",props.cnpj) : mask("##.###.###/####-##",props.cnpj)} 
                 //onChange={handleCnpj}
                 />
                 {/* {formatar(document.getElementById("cont_cnpj"+props.id),"cnpjorcpf")} */}
          <button onClick={() => PesquisaCNPJ(document.getElementById("cont_cnpj"+cod_transacao).value,"cont_nome"+props.cod_transacao)} 
                  className="btn btn-outline-secondary btn-sm" 
                  type="button" id="button-addon2"><i className="bi bi-search"></i></button>
        </div>
      </div>
      <div className="col col-md-4" >
        <input type="text" id={"cont_nome"+props.cod_transacao} className="form-control" maxLength="40"
               value ={cont_nome}
               onChange={(e) => setContNome(e.target.value)} 
        />
      </div>    
      <div className="col-md-2">
        {/* <label for="vencimento" className="form-label">Vencimento</label> */}
        <input type="date" id="vencimento" className="form-control"   value={trans_dt_vencto} onChange={(e) => {setTransDtVencto(e.target.value); setAlterado(true)}}/>
      </div>    
      <div className="col-md-2">
          <input
            type="text"
             id={"valor"+props.cod_transacao}
             className="form-control"        
             value={trans_valor}
             //defaultValue={new Intl.NumberFormat('pt-BR', {style: 'currency',currency: 'BRL'}).format(parseFloat(props.valor))}
           //  decimalSeparator="," 
           //  groupSeparator="."
             //decimalsLimit={2}
             //intlConfig={{ locale: 'pt-BR', currency: 'BRL'}}
             onChange={(e) => {setTransValor(e.target.value); setAlterado(true)}}
             style={{"text-align": "right"}}/>        
        {/* <input type="text" id="valor" className="form-control" style={{"text-align": "right"}}  defaultValue ={props.valor} onChange={(e) => {setTransValor(e.target.value); setAlterado(true)}}/> */}
      </div>    
      <div className="col-md-1" id="div-botoes-receber">
        {props.cod_transacao<0 || alterado ?
          <button onClick={() => SalvarReceber(props)} className="btn btn-primary btn-sm" type="button" id="button-salvar-receber"><i className="bi bi-floppy"></i></button>
           :<></>}
        {/* {((props.cod_transacao >= 0) && alterado) ?
          <button onClick={() => SalvarAlteracaoReceber(props)} className="btn btn-primary btn-sm" type="button" id="button-salvaralteracao-receber"><i className="bi bi-floppy"></i></button>
           :<></>}  */}
        {props.cod_transacao >= 0 ?
          <button onClick={() => ExcluirReceber(props)} className="btn btn-danger btn-sm" type="button" id="button-excluir-receber"><i className="bi bi-trash3-fill"></i></button>
           :<></>} 
      </div>    
    </form>

}

export default Receber; 

